import { MenuProps, Row } from "antd";
import { useCallback, useMemo, useState, MouseEvent } from "react";
import { usePrintHistory } from "./usePrintHistory";
import { Dayjs } from "dayjs";

export const usePrintOptions = (contractId: string, range: [Dayjs, Dayjs]) => {
  const [openTaxModal, setOpenTaxModal] = useState(false);

  const openTax = useCallback(() => setOpenTaxModal(true), []);

  const [histiryType, setHistoryType] = useState<0 | 1 | 2>(0);

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { printHistory } = usePrintHistory(setIsLoading);

  const openHistoryModal = useCallback((e: MouseEvent<HTMLDivElement>) => {
    const id: string = e.currentTarget.id;

    setHistoryType(id === "2" ? 1 : 2);
  }, []);

  const printFull = useCallback(() => {
    printHistory({
      contractId,
      reportType: 0,
      beginYear: range[0].year(),
      endYear: range[1].year(),
    });
  }, [contractId, printHistory, range]);

  const printOptions: MenuProps["items"] = useMemo(
    () => [
      {
        key: "1",
        label: <Row onClick={printFull}>Full History</Row>,
      },
      {
        key: "2",
        label: (
          <Row id="2" onClick={openHistoryModal}>
            Payer History
          </Row>
        ),
      },
      {
        key: "3",
        label: (
          <Row id="3" onClick={openHistoryModal}>
            Payee History
          </Row>
        ),
      },
      {
        key: "4",
        label: <Row onClick={openTax}>Tax 1098</Row>,
      },
    ],
    [openHistoryModal, openTax, printFull]
  );

  return {
    openTaxModal,
    printOptions,
    histiryType,
    setOpenTaxModal,
    setHistoryType,
    isLoading,
  };
};
